
import { defineComponent, ref } from "vue";
import useTodo from "@/composables/useTodo";
import TodoItem from "./TodoItem.vue";

export default defineComponent({
  name: "TodoList",

  components: { TodoItem },

  setup() {
    const { todos, filteredTodos, updateStorage } = useTodo();

    const dragging = ref(-1);

    function dragStart(i: number) {
      dragging.value = i;
    }

    function dragEnd() {
      dragging.value = -1;
    }

    function dragFinish(to: number) {
      todos.value.splice(to, 0, todos.value.splice(dragging.value, 1)[0]);
      updateStorage();
    }

    return {
      todos,
      filteredTodos,
      dragStart,
      dragEnd,
      dragFinish
    };
  }
});
